import React from 'react';

// "HOW IT WORKS" three-step explainer for the Create scan surface. Shared by the
// desktop info card and the mobile intro screen.
export const SCAN_STEPS = [
  { n: '1', title: 'Align your face', sub: 'Fill the guide frame, eyes level.' },
  { n: '2', title: 'Run the scan', sub: 'We map 32 facial vectors in seconds.' },
  { n: '3', title: 'Get your verdict', sub: 'Score, feedback, and a regimen.' },
];

const HowItWorks = ({ className = '' }) => (
  <div className={className}>
    <div className="font-display uppercase text-xs tracking-[0.24em] text-[#E8E2D6]">
      HOW IT WORKS
    </div>
    <div className="mt-[18px] flex flex-col gap-0.5">
      {SCAN_STEPS.map((step) => (
        <div
          key={step.n}
          className="flex items-center gap-4 py-[15px] border-b border-[rgba(255,255,255,0.06)]"
        >
          <div className="w-[38px] h-[38px] rounded-full border border-[rgba(201,164,92,0.5)] flex items-center justify-center shrink-0 font-display text-base text-aurum">
            {step.n}
          </div>
          <div>
            <div className="font-display text-[17px] text-bone">{step.title}</div>
            <div className="font-display text-[15px] text-bone-dim mt-px">{step.sub}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default HowItWorks;
